import { render, staticRenderFns } from "./ElementTypeView.vue?vue&type=template&id=32b112ea&scoped=true&"
import script from "./ElementTypeView.vue?vue&type=script&lang=ts&"
export * from "./ElementTypeView.vue?vue&type=script&lang=ts&"
import style0 from "./ElementTypeView.vue?vue&type=style&index=0&id=32b112ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b112ea",
  null
  
)

export default component.exports